<template>
  <div>
    <div>
      <div v-for="file in value" :key="'audio-' + file.id">
        <audio-player :file="file.url" :key="'audio-player-' + file.id" v-if="file.url"></audio-player>
      </div>
    </div>
    <div class="mt-2">
      <b-form-file v-model="newFile" accept="audio/*"></b-form-file>
      <loading-button variant="primary" block :loading="loading" class="mt-2" :disabled="!newFile" @submit="uploadFile" v-show="newFile">
        <font-awesome-icon icon="cloud-upload-alt"></font-awesome-icon> Upload Upload
      </loading-button>
    </div>
  </div>
</template>

<script>
import AudioPlayer from '../AudioPlayer';

export default {
  name: 'CourseBuilderAudio',
  components: {AudioPlayer},
  data () {
    return {
      newFile: null,
      loading: false
    };
  },
  methods: {
    uploadFile () {
      this.loading = true;
      let formData = new FormData();
      if (!Array.isArray(this.newFile))
        this.newFile = Array(this.newFile); // convert to array if single file

      this.newFile.forEach((file, idx) => formData.append(`file${idx}`, file));

      this.axios.post('/components/' + this.component_id + '/upload/audio', formData).then(rsp => {
        this.$emit('input', rsp.data);
        this.loading = false;
        this.newFile = null;
        this.$snotify.success('Audio Uploaded');
      }).catch(err => this.$errorOut(err))
    }
  },
  props: ['value', 'component_id']
};
</script>

<style scoped>

</style>